<div class="bottom-footer">
  <footer class="medworldexpo-footer p-2">
    <div class="container">
      <div class="row">
        <div class="col-md-6 pt-4">
          <img src="./assets/images/account_type/whitelogo.svg" alt="logo of medworld">
          <p class="text-white mt-2" style="text-align: justify;">
            Digiworld Expo is a digital platform offering industry-specific solutions across multiple sectors. We provide global market access, networking opportunities, and advanced tools for showcasing products and services. Our mission is to revolutionize expos, enabling professionals to connect, collaborate, and stay ahead of industry trends.
          </p>
        </div>
        <div class="col-md-2"></div>
        <div class="col-6 col-md-2 pt-4 mx-auto">
          <h4 class="text-white" style="font-weight: bold; margin-bottom: 7px;">Useful Links</h4>
          <ul class="text-white usefullinks">
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/products-view']">Products </li></a>
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/brands']">Brands</li></a>
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/healthcareServices']">Healthcare Services</li></a>
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/news_insights']">News & Insights</li></a>
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/knowledge_center']">Knowledge Center</li></a>
           <a (click)="smoothScrollToUp($event)"> <li [routerLink]="['/jobs']">Jobs</li></a>
          </ul>
        </div>          

        <div class="col-6 col-md-2 pt-4">
          <h4 class="text-white" style="font-weight: bold; margin-bottom: 7px;">Know More</h4>
          <ul class="text-white knowmore">
            <li><a href="/aboutus" class="text-white" style="text-decoration: none;">About Us</a></li>
            <li><a href="/how-it-work" class="text-white" style="text-decoration: none;">How It Works</a></li>
            <li><a href="/signup" class="text-white" style="text-decoration: none;">Exhibit With Us</a></li>
            <li><a href="/privacy-policy" class="text-white" style="text-decoration: none;">Privacy Policy</a></li>
            <li><a href="/refund-policy" class="text-white" style="text-decoration: none;">Refund Policy</a></li>
            <li><a href="/terms-and-conditions" class="text-white" style="text-decoration: none;">Terms & Conditions</a></li>
            <li><a href="/contactus" class="text-white" style="text-decoration: none;">Contact Us</a></li>
          </ul>
        </div>

      </div>
    </div>
  </footer>

  <div class=" sub-container bg-dark p-2">
    <div class="container-subfooter">
      <div><p class="m-0 text-white">© 2024 Medworld. All rights reserved.</p></div>
      <div class="social-media-links" style="display: flex; flex-direction: row; gap: 20px">
        <a style="background-color: #0d87c8 !important; border-radius: 50%;" href="https://www.facebook.com/people/Medworld-Expo/61567187572001/" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Facebook App Symbol.svg" alt="f" class="social-media-imgs"></a>
        <a style="background-color: #0d87c8 !important; border-radius: 50%;" href="https://x.com/Medworld_Expo" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Twitter.svg" alt="f" class="social-media-imgs"></a>
        <a style="background-color: #0d87c8 !important; border-radius: 50%;" href="https://www.youtube.com/@MedworldExpo" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Youtube.svg" alt="f" class="social-media-imgs"></a>
        <a style="background-color: #0d87c8 !important; border-radius: 50%;" href="https://www.linkedin.com/company/medworld-expo/" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Linkedin Big Logo.svg" alt="f" class="social-media-imgs"></a>
        <a style="background-color: #0d87c8 !important; border-radius: 50%;" href="https://www.instagram.com/medworld_expo/" target="_blank" rel="noopener noreferrer"><img src="./assets/images/account_type/Instagram.svg" alt="InstagramImg" class="social-media-imgs"></a>
      </div>
    </div>
  </div>

</div>
